import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { Message } from "../../../library-js/messages/Message";
import { Validator } from "../../../library-js/validators/Validator";
import { NotEmptyValidator } from "../../../library-js/validators/NotEmptyValidator";
import { Rokojori } from "../../js/Rokojori";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { OnChange, OnInput } from "../../../library-js/dom-tools/EventListeners";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { MessageWriter } from "../../../library-js/messages/MessageWriter";

export class ValidationField
{
  static readonly inputValidation = new ElementType( "input-validation" );
  static readonly fieldName = new ElementAttribute( "name" );
  static readonly inputCheck = new ElementType( "input-check" );
  static readonly openFlag = new ClassFlag( "open" );
  static readonly invalidFlag = new ClassFlag( "invalid" );
  static readonly checkedFlag = new ClassFlag( "checked" );

  element:Element;
  validators:Validator[];
  errorMessage:MultiString;
  isValid = false;
  selector:AttributeValue;
  valueBefore:string;
  inputElement:HTMLInputElement;

  constructor( name:string, validators:Validator[], errorMessage:MultiString = { en:"This field is mandatory" } )
  {
    this.selector = new AttributeValue( ValidationField.fieldName, name );
    this.validators = validators;
    this.errorMessage = errorMessage;

    this.getElements();

    this.valueBefore = this.inputElement.value;
  } 

  getElements()
  {
    this.element = this.selector.queryDoc();
    this.inputElement = ElementType.input.query( this.element );
  }

  validate( messageWriter:MessageWriter = null, forceCheck:boolean = false )
  {
    let textContent = this.inputElement.value;

    if ( ! forceCheck && ( textContent == this.valueBefore ) )
    {
      /// console.log( "Not Validating:", this.selector.value, textContent, this.valueBefore, this.inputElement.value );
      return;
    }

    // console.log( "Validating:", this.selector, textContent );

    this.valueBefore = textContent;

    let checks = 0;
    this.validators.forEach(
      ( v )=>
      {
        v.messageWriter = messageWriter;
        let isValid = v.validate( textContent );

       // console.log( "Validation Result:", isValid, "for", v );
        if ( isValid )
        {
          checks ++;
        }
      }
    )

    this.isValid = checks === this.validators.length;

    let inputValidation = ValidationField.inputValidation.query( this.element );

    let inputCheck = ValidationField.inputCheck.query( this.element );
  
    
    if ( this.isValid )
    { 
      ValidationField.checkedFlag.setSolo( inputCheck );      
    }
    else
    {
      ValidationField.invalidFlag.setSolo( inputCheck );
    }
  }
}

export class PayPalValidator
{
  static readonly checkoutButton = new ElementType<HTMLElement>( "checkout-button" );
  nameField:ValidationField;
  emailField:ValidationField;

  streetField:ValidationField;
  placeField:ValidationField;
  countryField:ValidationField;

  termsCheck:HTMLInputElement;  

  messages:Message[];
  isValid:boolean = false;

  button:HTMLElement;

  static readonly termsCheckSelector = new AttributeValue( ValidationField.fieldName, "terms-check" );

  constructor()
  {
    let notEmptyValidators = [ new NotEmptyValidator() ];
    let emailValidator = [ new NotEmptyValidator(), new EmailValidator() ];

    this.nameField   = new ValidationField( "Full Name", notEmptyValidators );
    this.emailField  = new ValidationField( "Email", emailValidator );

    this.streetField  = new ValidationField( "Street Number", notEmptyValidators );
    this.placeField   = new ValidationField( "ZipCode City", notEmptyValidators );
    this.countryField = new ValidationField( "Country", notEmptyValidators );

    this.termsCheck = PayPalValidator.termsCheckSelector.queryDoc() as HTMLInputElement;

    this.button = PayPalValidator.checkoutButton.queryDoc();

    this.validationFields.forEach(
      ( v )=>
      {
        let input = ElementType.input.query( v.element );
        OnChange.add( input, ()=>{ this.check() } );
        OnInput.add( input , ()=>{ this.check() } );
      }
    )

    OnChange.add( this.termsCheck , ()=>{ this.check() } );
    OnInput.add( this.termsCheck , ()=>{ this.check() } );

    this.check( true );
  }

  get validationFields()
  {
    return [ this.nameField, this.emailField, this.streetField, this.placeField, this.countryField ];
  }

  check( forceCheck:boolean = false )
  {
    
    this.validationFields.forEach( 
      vf => 
      {
        let messageWriter = new MessageWriter( this.messages);
        vf.validate( messageWriter,  forceCheck )
      } 
    );

    let invalidFieldIndex = this.validationFields.findIndex( ( p ) => ! p.isValid );

    this.isValid = this.termsCheck.checked && ( invalidFieldIndex === -1 );

    // console.log( this.isValid, invalidFieldIndex, this.termsCheck.checked );

    ClassFlag.disabled.setAs( this.button, ! this.isValid );

  }

}